import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, inject } from '@angular/core';
import { IrisDataRepoFile } from '@iris/common/modules/files-common/models/IrisDataRepoFile';
import { IrisFilePreviewType, IrisFilesService } from '@iris/common/modules/dms/services/files.service';
import { IrisDmsModalsSandbox } from '@iris/common/modules/dms/sandbox/dms-modals.sandbox';
import { IrisDMSFileI } from '@iris/common/modules/dms/models/IrisDMSFile';
import { take } from 'rxjs';

@Component({
  selector: 'iris-file-preview-thumbnail',
  templateUrl: './file-preview-thumbnail.component.html',
  styleUrls: ['./file-preview-thumbnail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IrisFilePreviewThumbnailComponent {
  private readonly filesService = inject(IrisFilesService);
  private readonly dmsModalsSandbox = inject(IrisDmsModalsSandbox);

  @Input() height: number;
  @Input() width: number;
  @Input() objectFitCover = false;
  @Input() borderRadius = 0;
  @Input() iconSize: number;
  @Input() set file(file: IrisDataRepoFile | IrisDMSFileI) {
    this._file = file;
    this.isImgLoadingError = false;
    this.setPreviewLink();
  }

  get file(): IrisDataRepoFile | IrisDMSFileI {
    return this._file;
  }

  @Input() showDownload = true;

  @Input() showPreview = true;

  @Input() showEdit = false;

  @Output() editClicked = new EventEmitter<IrisDMSFileI>();

  isImgLoadingError = false;

  previewLink = '';

  private _file: IrisDataRepoFile | IrisDMSFileI;

  get previewType(): string {
    return this.filesService.getPreviewType(this.file);
  }

  get hasPreview(): boolean {
    return !this.isImgLoadingError && (this.previewType === IrisFilePreviewType.Image || !!this.file.thumbId);
  }

  get fileIcon(): string {
    return this?.filesService.getIconClass(this.file);
  }

  get isOfficeEditableDocument(): boolean {
    return this.filesService.isOfficeFileEditable(this.file as IrisDMSFileI);
  }

  showFilePreviewModal(): void {
    this.dmsModalsSandbox.showFilePreviewModal(this.file, null, false);
  }

  showOfficeEditModal(): void {
    this.dmsModalsSandbox.showOfficeEditorModal(this.file as IrisDMSFileI);
  }

  setPreviewLink(): void {
    const previewId = this.file.thumbId ? this.file.thumbId : this.file.id;
    if ( !previewId ) { return; }
    this.previewLink = this.filesService.getFilePreviewUrl(previewId);
  }

  onEdit(): void {
    this.editClicked.emit(this.file as IrisDMSFileI);
  }

  downloadFile(): void {
    this.filesService.downloadFile(this.file.id, this.file.name).pipe(
      take(1),
    ).subscribe();
  }
}
